import { useEffect } from "react";
import { useAppStore } from "store/store";

import ChecklistResolutionStatus from "../../../../models/checklist/checklist-resolution-status";
import Journey from "../../../../models/journey/journey";
import PaxSession from "../../../../models/session/pax-session";
import { daysBeforeDate, hoursBeforeDate } from "../../../../utils";
import useMutatedPagePath from "./useMutatedPagePath";
import AnalyticsService from "services/analytics/analytics";

export const getGeneralAnalyticsParams = (
  paxSessions: PaxSession[],
  journey: Journey | null,
  path: string,
  title: string,
  location: string,
  locale: string
): { [key: string]: any } => {
  const readyToFlyPaxCount = paxSessions.filter(
    (p) => p.checklist.resolutionStatus === ChecklistResolutionStatus.ReadyToFly
  ).length;

  const options: { [key: string]: any } = {
    all_pax_count: paxSessions.length,
    ready_to_fly_pax_count: readyToFlyPaxCount,
    all_pax_ready_to_fly: readyToFlyPaxCount === paxSessions.length ? 1 : 0,
    page_path: path,
    content_group: path,
    page_location: location,
    page_title: title,
    language: locale,
  };

  if (journey) {
    const daysBeforeDeparture = daysBeforeDate(
      journey.departure.departureLocalDatetime
    );
    options["days_to_departure"] = daysBeforeDeparture;

    if (daysBeforeDeparture <= 1) {
      options["hours_to_departure"] = hoursBeforeDate(
        journey.departure.departureLocalDatetime
      );
    }
  }
  return options;
};

const useGeneralAnalytics = () => {
  const locale = useAppStore((state) => state.locale);
  const [path, title, location] = useMutatedPagePath();
  const paxSessions = useAppStore((state) => state.paxSessions);
  const journey = useAppStore((state) => state.journey);

  useEffect(() => {
    AnalyticsService.shared.trackEvent(
      "page_view",
      {
        ...getGeneralAnalyticsParams(
          paxSessions,
          journey,
          path,
          title,
          location,
          locale
        ),
      },
      false // isScanRelated
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useGeneralAnalytics;
